const productKey = (product) =>
    product?.organization_item
        ? `organization-${product.itemID || product.id}`
        : `regular-${product?.item_sale?.product?.id || product.id}`;

export default {
    state: () => ({
        cart: [],
    }),
    getters: {
        getTotal(state) {
            return state.cart
                .reduce((acc, product) => {
                    return acc + product.price1 * (product.amount || 1);
                }, 0)
                .toFixed(2);
        },
        isInCart(state) {
            return (prod) => {
                return (
                    state.cart.findIndex(
                        (product) => productKey(product) === productKey(prod)
                    ) !== -1
                );
            };
        },
    },
    mutations: {
        updateCart(state, payload) {
            state.cart = [...payload];
        },
        addToCart(state, payload) {
            // Add the new item to the cart
            state.cart = [payload, ...state.cart];

            // Sort the cart so items with billing_product come first
            state.cart.sort((a, b) => {
                if (!!a.organization_item !== !!b.organization_item) {
                    return a.organization_item ? -1 : 1;
                }
                const aHasBillingProduct = !!a?.item_sale?.product?.billing_product;
                const bHasBillingProduct = !!b?.item_sale?.product?.billing_product;

                // Prioritize items with billing_product
                if (aHasBillingProduct && !bHasBillingProduct) {
                    return -1; // a comes first
                } else if (!aHasBillingProduct && bHasBillingProduct) {
                    return 1; // b comes first
                } else {
                    return 0; // No change in order for items with both or neither having billing_product
                }
            });
        },
        removeFromCart(state, payload) {
            state.cart = state.cart.filter(
                (product) => productKey(product) !== productKey(payload)
            );
        },
        removeAllFromCart(state) {
            state.cart = [];
        },
        removeBillingProducts(state) {
            state.cart = state.cart.filter(
                (product) => !product?.item_sale?.product?.billing_product
            );
        },
        updateAmount(state, payload) {
            const item = state.cart.find(
                (product) => productKey(product) === productKey(payload)
            );
            if (item) {
                item.amount = payload.amount;
            }
        },
    },
    actions: {
        updateCart(context, payload) {
            context.commit("updateCart", payload);
        },
        addToCart(context, payload) {
            context.commit("addToCart", payload);
        },
        removeFromCart(context, payload) {
            context.commit("removeFromCart", payload);
        },
        removeAllFromCart(context) {
            context.commit("removeAllFromCart");
        },
        updateAmount(context, payload) {
            context.commit("updateAmount", payload);
        },
    },
    namespaced: true,
};
